import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from "../../components/Footer";
import TreatmentsTemplate from '../../components/Treatments-template'
import surgicalImg from '../media/surgical.jpg'
import surgical2Img from '../media/surgical2.jpg'
import {useTranslation, Trans} from 'react-i18next'



export default function Sugergy() {

    const { t } = useTranslation();
    return (
        <>
            <Navbar></Navbar>
            <TreatmentsTemplate 
            backgroundImage = {surgicalImg}
            title = {t('sugeTile')}
            paragraph = {t('sugeSubtitle')}
            addClass = "min-width" 
            mediaContent = 
            {
            `# ${t('sugeTile')}
***  
${t('sugeParaf')}
![](${surgical2Img})
            `
            }
             >
            
            </TreatmentsTemplate>
            <Footer></Footer>
        </>
    )
}
